module.exports = __webpack_public_path__ + "img/thumbnail_Binturong_m_normal.d33d948a.png";